import { createBrowserClient } from '@supabase/ssr'

// 🛡️ PATRÓN SINGLETON: Guarda la instancia en memoria para evitar múltiples clientes
let browserClient;

export function createClient() {
  if (!browserClient) {
    browserClient = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
    );
  }
  return browserClient;
}


